import { action } from 'typesafe-actions';
import {
  PRICING_TIERS_FAILURE,
  PRICING_TIERS_REQUEST,
  PRICING_TIERS_SUCCESS,
  COUPON_REQUEST,
  COUPON_SUCCESS,
  COUPON_FAILURE,
  TIP_PRODUCT_REQUEST,
  TIP_PRODUCT_SUCCESS,
  TIP_PRODUCT_FAILURE,
} from '../../constants/tips';

export const pricingTiersRequestAction = () => action(PRICING_TIERS_REQUEST);
export const pricingTiersSuccessAction = (data: any) =>
  action(PRICING_TIERS_SUCCESS, data);
export const pricingTiersFailureAction = (e: any) =>
  action(PRICING_TIERS_FAILURE, e);

export const couponRequestAction = () => action(COUPON_REQUEST);
export const couponSuccessAction = (coupons: any) =>
  action(COUPON_SUCCESS, coupons);
export const couponFailureAction = (e: any) => action(COUPON_FAILURE, e);

export const tipProductRequestAction = (tipID: string) =>
  action(TIP_PRODUCT_REQUEST, tipID);
export const tipProductSuccessAction = (tip: any) =>
  action(TIP_PRODUCT_SUCCESS, tip);
export const tipProductFailureAction = (e: any) =>
  action(TIP_PRODUCT_FAILURE, e);

export const tipsActions = {
  pricingTiersRequestAction,
  pricingTiersSuccessAction,
  pricingTiersFailureAction,
  couponRequestAction,
  couponFailureAction,
  couponSuccessAction,
  tipProductRequestAction,
  tipProductFailureAction,
  tipProductSuccessAction,
};
